import React, { useState } from "react";
import { useSelector } from "react-redux";

import "./Navigation.scss";
import { clearStorageData } from "../../helpers/upLoadHelper";
import { SignOutLink } from "./links/SignOutLink";
import { GenericLink } from "./links/GenericLink";
import { MyHomeLink } from "./links/MyHomeLink";
import { InboxLink } from "./links/InboxLink";

const Navigation = ({ links, collapseSideBar }) => {
  const userSuiteList = useSelector(
    (state) => state?.userSuites?.userSuiteList || []
  );
  const [loading, setLoading] = useState(false);

  if (userSuiteList && userSuiteList.length > 0) {
  } else {
    links = links.filter((link) => link.label !== "My Home");
  }

  const handleSignOut = async () => {
    localStorage.removeItem("isAnnotationImageUpload");
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      clearStorageData();
    }, 1000);
  };
  return (
    <nav className="navigation">
      <ul className="navigation__links">
        {links.map((link, i) => {
          switch (link.label) {
            case "Sign Out":
              return (
                <SignOutLink
                  link={link}
                  loading={loading}
                  collapseSideBar={collapseSideBar}
                  onClick={() => {
                    window.confirm("Are you sure you want to sign out?") &&
                      handleSignOut();
                  }}
                />
              );
            case "My Home":
              return (
                <MyHomeLink link={link} collapseSideBar={collapseSideBar} />
              )
            case "Inbox":
              return (
                <InboxLink link={link} collapseSideBar={collapseSideBar} />
              );
            default:
              return (
                <GenericLink link={link} collapseSideBar={collapseSideBar} />
              );
          }
        })}
      </ul>
    </nav>
  );
};

export default Navigation;
